import styles from './NeedMoreCard.module.css';

interface NeedMoreCardProps {
	onContact: () => void;
}

export const NeedMoreCard = ({ onContact }: NeedMoreCardProps) => {
	return (
		<section className={styles.card}>
			<h3 className={styles.title}>Precisa de mais?</h3>
			<p className={styles.text}>
				Planos sob medida para equipes e operações com volume acima do catálogo atual.
			</p>
			<button type="button" className={styles.cta} onClick={onContact}>
				Falar com comercial
			</button>
		</section>
	);
};
